"use strict"

const IS_DEV = (typeof window.site === 'undefined' || typeof window.site.isAdmin === 'undefined')
	? false : window.site.isAdmin

/**
 * Выводит отладочную информацию в консоль в режиме разработчика.
 * Пример: dd({a: window.site, b: window.site.sys.is_dev, c:IS_DEV}, 'warn')
 * @param {*} data - Данные для вывода. Могут быть любого типа.
 * @param {string} [type='info'] - Тип выводимого сообщения, который соответствует методам объекта console. По умолчанию 'info'.
 */
const DD = new class {
	log(...data) 		{IS_DEV ? console.log(...data) : null}
	warn(...data) 	{IS_DEV ? console.warn(...data) : null}
	error(...data) 	{IS_DEV ? console.error(...data) : null}
	info(...data) 	{IS_DEV ? console.info(...data) : null}
	bool(result, ...data) {
		if(IS_DEV !== true) return false
		result ? this.log('✅ ', ...data) : this.error('❌ ', ...data)
	}
}
const dd = (...text)=>DD.log(...text)


document.addEventListener("DOMContentLoaded", ()=>{
	document.querySelector('body').classList.add('_loaded')

	// переход по якорным ссылкам
	document.querySelectorAll('a[href^="#"]').forEach(link => {
		link.addEventListener("click", (e)=>{
			e.preventDefault()
			const targetElementId = link.getAttribute("href")
			const targetElement = document.querySelector(targetElementId)
			if (targetElement) {
				targetElement.scrollIntoView({behavior: "smooth"})
			}
		})
	})



	// textarea autosize
	function autosizeCalcHeight(ev) {
		let el = ev.target
		el.style.height = 'auto'
		// el.style.height = el.scrollHeight + 'px'
		el.style.height = el.value == ''
			? el.offsetHeight + 'px'
			: el.scrollHeight + 'px'
	}
	document.querySelectorAll('.autosize').forEach(autosize_field => {
		autosize_field.addEventListener('input', ev => {
			autosizeCalcHeight(ev)
		})
		autosize_field.addEventListener('focus', ev => {
			autosizeCalcHeight(ev)
		})
		autosize_field.addEventListener('blur', ev => {
			autosizeCalcHeight(ev)
		})
	})


	// to_top_btn
	const to_top_btn = document.querySelector("#to_top_btn")
	if(to_top_btn != null) {
		to_top_btn.addEventListener("click", function() {
			window.scroll({top: 0, behavior: "smooth"});
		})
	}
})



// переключение класса
function toggleClass(el, className = "_active", self = null) {
	if(typeof el == 'string') el = document.querySelector(el)
	el.classList.toggle(className)
	if(self !== null) self.classList.toggle('_toggled')
}



// скролл страниц
class ScrollWatcher {
	constructor() {
		this.scrollClass = '_scrolled'
		this.scrollingClass = '_scrolling'
		this.dirClasses = {
			up: '_scroll—top',
			down: '_scroll—bottom'
		}
		this.longDirClasses = {
			up: '_scroll—top_long',
			down: '_scroll—bottom_long'
		}

		this.prevScroll = window.scrollY
		this.lastDir = null
		this.dirStartTime = null
		this.scrollTimeout = null

		this.SCROLL_LONG_DELAY = 2000 // ms

		this.onScroll = this.onScroll.bind(this)
		this.onScrollEnd = this.onScrollEnd.bind(this)

		window.addEventListener('scroll', this.onScroll, { passive: true })
		this.onScroll()
	}

	onScroll() {
		const y = window.scrollY
		const body = document.body

		// _scrolled toggle
		if (y >= 1) body.classList.add(this.scrollClass)
		else body.classList.remove(this.scrollClass)

		let dir = null
		if (y > this.prevScroll) dir = 'down'
		else if (y < this.prevScroll) dir = 'up'

		if (dir) {
			// _scrolling: добавлять только если ещё нет
			if (!body.classList.contains(this.scrollingClass))
				body.classList.add(this.scrollingClass)

			// _scroll—top/_scroll—bottom: снимать все, добавлять только если нет
			Object.values(this.dirClasses).forEach(cls => {
				if (cls !== this.dirClasses[dir]) body.classList.remove(cls)
			})
			if (!body.classList.contains(this.dirClasses[dir]))
				body.classList.add(this.dirClasses[dir])

			// _scroll—top_long/_scroll—bottom_long: сбрасываем при смене направления
			Object.values(this.longDirClasses).forEach(cls => {
				if (cls !== this.longDirClasses[dir]) body.classList.remove(cls)
			})

			// direction changed
			if (this.lastDir !== dir) {
				this.dirStartTime = performance.now()
				Object.values(this.longDirClasses).forEach(cls => body.classList.remove(cls))
			} else if (this.dirStartTime && performance.now() - this.dirStartTime > this.SCROLL_LONG_DELAY) {
				if (!body.classList.contains(this.longDirClasses[dir]))
					body.classList.add(this.longDirClasses[dir])
			}

			this.lastDir = dir
		}

		this.prevScroll = y

		clearTimeout(this.scrollTimeout)
		this.scrollTimeout = setTimeout(this.onScrollEnd, this.SCROLL_LONG_DELAY)
	}

	onScrollEnd() {
		const body = document.body
		body.classList.remove(this.scrollingClass)
		Object.values(this.dirClasses).forEach(cls => body.classList.remove(cls))
		Object.values(this.longDirClasses).forEach(cls => body.classList.remove(cls))
		this.dirStartTime = null
		this.lastDir = null
	}
}
new ScrollWatcher()



/* Куки - пример использования
const cookieValue = Cookie.get('cookie_name');
Cookie.set('cookie_name', 'cookie_value', 7);
Cookie.delete('cookie_name');
*/
const Cookie = {
  get: function(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  },

  set: function(name, value, days = 365) {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + expirationDate.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  },

	delete: function(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
}



/**
 * toggleItem - Гибкая утилита для управления классами и backrop на элементах интерфейса.
 *
 * @param {Object} args
 * @param {string|Element} [args.el='body']
 * @param {string|string[]} [args.class='show__toggled']
 * @param {string|Element} [args.self=null]
 * @param {string|string[]|boolean} [args.self_class='active']
 * @param {boolean} [args.backdrop=true]
 */
window.toggleItem = function(args = {}) {
	// Предотвращаем дефолтное поведение события (если оно существует)
  window.event?.preventDefault()

  class ToggleItem {
    constructor(options) {
      const defaults = {
        el: 'body',
        class: 'show__toggled',
        self: null,
        self_class: 'active',
        backdrop: true
      }
      this.opts = { ...defaults, ...options }

      // Выбираем элементы
      this.target = typeof this.opts.el === 'string' ? document.querySelector(this.opts.el) : this.opts.el
      this.controller = typeof this.opts.self === 'string' ? document.querySelector(this.opts.self) : this.opts.self

      // Нормализуем классы
      this.targetClasses = Array.isArray(this.opts.class)
        ? this.opts.class
        : (typeof this.opts.class === 'string' ? this.opts.class.split(' ') : [])
      this.controllerClasses = this.opts.self_class
        ? (Array.isArray(this.opts.self_class)
          ? this.opts.self_class
          : (typeof this.opts.self_class === 'string' ? this.opts.self_class.split(' ') : []))
        : []

      this.backdropSelector = '.offcanvas-backdrop'

      // Проверка на ошибки
      if (!this.target) return

      // Уже открыт? Проверяем по наличию хотя бы одного класса (можно изменить на every)
      const isOpen = this.targetClasses.some(cls => this.target.classList.contains(cls))
      isOpen ? this.hide() : this.show()
    }

    toggleClasses(el, action, classList) {
      if (!el || !classList.length) return
      el.classList[action](...classList)
    }

    show() {
      this.toggleClasses(this.target, 'add', this.targetClasses)
      if (this.controller) {
        this.controller.classList.add('toggled')
        this.toggleClasses(this.controller, 'add', this.controllerClasses)
      }
      if (this.opts.backdrop) this.showBackdrop()
    }

    hide() {
      this.toggleClasses(this.target, 'remove', this.targetClasses)
      if (this.controller) {
        this.controller.classList.remove('toggled')
        this.toggleClasses(this.controller, 'remove', this.controllerClasses)
      }
      if (this.opts.backdrop) this.hideBackdrop()
    }

    showBackdrop() {
      // Если уже есть — не дублируем
      if (document.querySelector(this.backdropSelector)) return
      const el = document.createElement('div')
      el.className = 'offcanvas-backdrop fade'
      document.body.appendChild(el)
      setTimeout(() => el.classList.add('show'), 10)
      el.addEventListener('click', () => this.hide())
    }

    hideBackdrop() {
      document.querySelectorAll(this.backdropSelector).forEach(el => {
        el.classList.remove('show')
        setTimeout(() => el.remove(), 200)
      })
    }
  }

  new ToggleItem(args)
}



// Проверка необходимости скролла страницы
function checkDocumentScroll() {
	const bodyclass = '_no_scroll'
	document.documentElement.scrollHeight <= window.innerHeight
		? document.body.classList.add(bodyclass)
		: document.body.classList.remove(bodyclass)
}
window.addEventListener('resize', ()=>{ checkDocumentScroll() })
window.dispatchEvent(new CustomEvent('resize'))
// +при изменении DOM
const observer = new MutationObserver(function(mutationsList, observer) {checkDocumentScroll()})
observer.observe(document.body, {childList: true, subtree: true})



// Переключение темы шаблона и запоминание в Cookie
// function toggleTemplateTheme() {
// 	const themeEl = document.querySelector('html')
// 	const args = {
// 		cookieName: 'theme',
// 		themeEl: themeEl,
// 		currentTheme: themeEl.getAttribute('data-bs-theme'),
// 		themes: ['light', 'dark']
// 	}

// 	const switchedTheme = args.currentTheme == args.themes[0]
// 		? args.themes[1] : args.themes[0]
// 	args.themeEl.setAttribute('data-bs-theme', switchedTheme)
// 	Cookie.set(args.cookieName, switchedTheme)
// }



// Аналог mt_rand
function mt_rand(min = 0, max = 999999999) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}


function checkAlertAutoclose() {
	document.querySelectorAll('[data-alert-autoclose]').forEach(alertEl => {
		const autoclose = alertEl.getAttribute('data-alert-autoclose');
		setTimeout(() => new bootstrap.Alert(alertEl).close(), autoclose)
	})
}
document.addEventListener("DOMContentLoaded", checkAlertAutoclose)
new MutationObserver(checkAlertAutoclose).observe(document, { childList: true, subtree: true })


/*
	Отложенная загрузка скриптов и стилей
	Пример: loadResources([
	'https://cdnjs.cloudflare.com/ajax/libs/fancyapps-ui/5.0.36/fancybox/fancybox.umd.js',
	'https://cdnjs.cloudflare.com/ajax/libs/fancyapps-ui/5.0.36/fancybox/fancybox.min.css',
	], 3000).then(() => {...}).catch((e) => console.error(e))
	v.0.1.250501 - начало
	v.0.1.250503 - обработка ошибок
	v.0.2.251115 - игнор дублированных запросов
*/

// Общий кэш по URL: url -> Promise
const loadedResourcesCache = new Map();


function loadResources(urls, timeout = 0) {
  // Нормализуем вход
  if (typeof urls === 'string') urls = [urls];
  if (!Array.isArray(urls)) {
    return Promise.reject(new Error('loadResources: "urls" должен быть строкой или массивом'));
  }

  // Вспомогательная функция, которая реально стартует загрузку
  const startLoading = () => {
    const promises = urls
      .map((rawUrl) => {
        const url = String(rawUrl).trim();
        if (!url) return Promise.resolve('Пустой URL пропущен');

        // Если уже есть Promise для этого URL — просто возвращаем его
        if (loadedResourcesCache.has(url)) {
					DD.warn('Дубль loadResources запроса:', url)
          return loadedResourcesCache.get(url);
        }

        // Создаём новый Promise загрузки
        const promise = new Promise((res, rej) => {
          const cleanUrl = url.split('?')[0].toLowerCase();
          const isCSS   = cleanUrl.endsWith('.css');
          const isJS    = cleanUrl.endsWith('.js');

          if (isCSS) {
            const link    = document.createElement('link');
            link.rel      = 'stylesheet';
            link.href     = url;
            link.onload   = () => res(`CSS загружен: ${url}`);
            link.onerror  = () => {
              // При ошибке убираем из кэша, чтобы позже можно было попробовать ещё раз
              loadedResourcesCache.delete(url);
              rej(new Error(`Не удалось загрузить CSS: ${url}`));
            };
            document.head.appendChild(link);

          } else if (isJS) {
            const script   = document.createElement('script');
            script.src     = url;
            script.async   = false; // если важно сохранить последовательность
            script.onload  = () => res(`JS загружен: ${url}`);
            script.onerror = () => {
              loadedResourcesCache.delete(url);
              rej(new Error(`Не удалось загрузить JS: ${url}`));
            };
            document.body.appendChild(script);

          } else {
            // Тип не поддерживается — не кэшируем такой URL
            rej(new Error(`Неподдерживаемый тип: ${url}`));
          }
        });

        // Кладём в кэш только корректные URL (JS/CSS)
        loadedResourcesCache.set(url, promise);
        return promise;
      });

    // Поведение как и раньше: один общий Promise
    return Promise.all(promises);
  };

  // Если задержка не нужна — сразу стартуем
  if (!timeout || timeout <= 0) {
    return startLoading();
  }

  // Иначе — оборачиваем в setTimeout
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      clearTimeout(timeoutId);
      startLoading()
        .then(resolve)
        .catch(reject);
    }, timeout);
  });
}
